// import { FlareSharp } from '@mui/icons-material';
import { FormHelperText, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Label } from '../Label/';

interface IControlledTextInput {
  labelText?: string;
  name: string;
  showMandatorySymbol?: boolean;
  changed?(value: string): void;
}

const ControlledTextInput: React.FC<TextFieldProps & IControlledTextInput> = ({
  labelText,
  name,
  showMandatorySymbol = false,
  ...props
}) => {
  const { control } = useFormContext();
  return (
    <>
      {labelText && (
        <Label>
          {labelText}
          {showMandatorySymbol ? ' *' : ''}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
          <>
            <TextField
              id={name}
              onChange={(event) => {
                onChange(event);
                props.changed?.(event.target.value);
              }}
              value={value}
              onBlur={onBlur}
              inputProps={{ style: { padding: '11.5px 14px' } }}
              {...props}
            />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </>
  );
};
export default ControlledTextInput;
